<template>
  <div class="food-manage">
    <div class="tuolele-main-box">
      <el-table :key="tableKey" :data="lists" border stripe>
        <el-table-column label="创建时间" prop="create_time" align="center" />
        <el-table-column label="最后操作时间" prop="modify_time" align="center" />
        <el-table-column label="退款单号" prop="refund_id" align="center" />
        <el-table-column label="学员ID" prop="sub_id" align="center" />
        <el-table-column label="学员姓名" prop="sub_name" align="center" />
        <el-table-column label="退款金额" align="center">
          <template slot-scope="{row}">
            {{ row.amount/100 }}元
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="{row}">
            <el-button type="text" @click="fnPopDetail(row)">订单详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="footer pagination-footer" style="text-align: center;">
      <el-pagination layout="prev, pager, next, slot, jumper" :current-page.sync="listQuery.p" prev-text="上一页" next-text="下一页" :total="listQuery.total" :page-size="listQuery.limit" @current-change="fnGetOrderSignLists" />
    </div>
    <el-dialog v-if="bShowDetail" title="退款详情" :visible.sync="bShowDetail">
      <refund-detail :refund="currentRefund" @auditsuccess="fnGetOrderSignLists()" />
    </el-dialog>
  </div>

</template>
<script>

import RefundDetail from './components/RefundDetail'
// import { validateRequire } from '@/utils/validate'

// import Tool from '@/assets/js/tool.js'

export default {
  name: 'TyyKnowledgeSettingLists',
  components: {
    RefundDetail
  },
  data() {
    return {
      lists: [],
      tableKey: 0,
      listQuery: {
        status: '',
        p: 1,
        limit: 20,
        total: 0
      },
      currentRefund: '',
      bShowDetail: false
    }
  },
  watch: { // 通过watch来监听路由变化
    '$route': function() {
      this.listQuery.status = this.$route.query.status
      this.fnGetOrderSignLists()
    }
  },
  created() {
    this.listQuery.status = this.$route.query.status
    this.fnGetOrderSignLists()
  },
  methods: {
    fnGetOrderSignLists: function() {
      this.bShowDetail = false
      this.$http.tyyGetRefundList(this.listQuery).then(res => {
        this.listQuery.total = parseInt(res.data.count)
        this.lists = res.data.list
      })
    },
    fnPopDetail: function(refund) {
      this.currentRefund = refund.refund_id
      this.bShowDetail = true
    }
  }
}
</script>
<style lang="scss">
  .food-search {
  .tuolele-main-search-item {
    margin-bottom: 0;
    padding: 0;
    border: 0;
    .el-form--inline .el-form-item {
      display: block;
    }
    .split-time{
      margin-right: 20px;
    }
    .el-select,
    .el-input {
      width: 160px !important;
      margin-right: 20px;
    }
    span.select-date {
      margin-right: 10px;
    }
    .button-group {
      margin-left: 82px;
    }
  }
}
</style>
